import styled from 'styled-components';
import { Card } from '@minerva-analytics/pantheon';
import { SKY_BLUE, SALMON, LIGHT_GRAY } from '../../theme';

export const LegalContainer = styled.div`
  width: 80%;
  display: flex;
  justify-content: center;
  margin: 0 auto 1rem auto;
`;

export const LegalCard = styled(Card)`
  border-top: 1rem solid ${SKY_BLUE}; 
  padding: 1rem 2.5rem;

  a {
    color: ${SALMON};
    font-family: 'Source Sans Pro', sans-serif;
  }

  p, li {
    font-family: 'Source Sans Pro', sans-serif;
    color: ${LIGHT_GRAY};
    line-height: 2rem;
    font-size: 1.125rem;
    font-weight: 400;
    letter-spacing: 0.68px;
  }

  h1, h2, h3, h4 {
    font-family: 'Poppins', sans-serif;
  }
`;